
import './App.css'
import './index.css'
import CarcassonneTracker from './CarcasonneTracker';

function App() {
  return (
    <CarcassonneTracker/>
  );
}

export default App;